import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgRapidlyExpandingCommunitySolid = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M1.7741 26.3816c1.0714 1.8554 3.0208 2.8932 5.0236 2.8932a5.75 5.75 0 0 0 2.8847-.7741h.0005c.0064-.0037.0122-.0083.0186-.012C11.5945 29.647 13.75 30.2578 16 30.2578c2.25 0 4.4058-.6108 6.2988-1.7693.0064.0038.0122.0084.0188.0122a5.747 5.747 0 0 0 2.8847.774c2.0023 0 3.9527-1.0377 5.0236-2.8931 1.5955-2.7647.645-6.3119-2.119-7.9074-.0116-.0066-.0236-.0115-.035-.018.0023-.0941.017-.1945.017-.2882 0-4.452-2.4428-8.5067-6.3009-10.6137 0-.008.0012-.0154.0012-.0234 0-3.1919-2.5969-5.7887-5.7892-5.7887s-5.7893 2.5968-5.7893 5.7887c0 .008.0012.0155.0013.0234C6.354 9.6613 3.911 13.716 3.911 18.168c0 .0937.0147.194.017.2882-.0114.0066-.0234.0114-.035.018-2.764 1.5955-3.7145 5.1427-2.119 7.9074m24.8804-5.3932h.0005c1.3776.7958 1.8512 2.5633 1.0558 3.9414-.7944 1.378-2.5638 1.8525-3.941 1.0567-1.378-.7958-1.8515-2.5643-1.0562-3.9423.3852-.6673 1.0071-1.1447 1.7514-1.344a2.88 2.88 0 0 1 .751-.1003c.5004 0 .9938.1314 1.4385.3885M16 4.6458c1.5912 0 2.8856 1.2944 2.8856 2.8851 0 1.5912-1.2944 2.8857-2.8856 2.8857s-2.8856-1.2945-2.8856-2.8857c0-1.5907 1.2944-2.8852 2.8856-2.8852m-4.9855 5.8134c1.0075 1.7087 2.8623 2.861 4.9855 2.861s3.978-1.1523 4.9855-2.861c2.458 1.5925 4.0144 4.2784 4.1654 7.2434-.4797.0058-.9616.065-1.4368.1922-1.4939.4008-2.7425 1.3583-3.5156 2.6976-1.0625 1.8409-.99 4.0272-.01 5.7556-1.2874.6607-2.7112 1.0062-4.1885 1.0062s-2.901-.3454-4.1883-1.0062c.9799-1.7283 1.0523-3.9147-.0102-5.7556-.7731-1.3394-2.0217-2.2968-3.5156-2.6976-.4754-.127-.9574-.1859-1.4369-.1917.1508-2.9653 1.7073-5.6513 4.1655-7.2439m-5.669 10.5292c.4447-.257.938-.3885 1.4385-.3885.2505 0 .5024.033.751.1002.7443.1994 1.3662.6768 1.7514 1.344.7953 1.3772.3218 3.1457-1.0558 3.9424-1.3767.7958-3.1465.3204-3.9414-1.0567-.7954-1.378-.3218-3.1456 1.0563-3.9414" />
  </svg>
);
export default SvgRapidlyExpandingCommunitySolid;
